import type { Infer } from 'superstruct';
import {
	nullable,
	number,
	object,
	optional,
	partial,
	string,
	trimmed,
} from 'superstruct';

import {
	emptyStringIsNull,
	parsableInteger,
} from '@adflow/shared/util-superstruct';

import { AddGoogleAdsAccountDto } from './google-ads-account.dto';

export const ViewGoogleAdsCampaignBudgetTemplateDto = object({
	id: number(),
	budget: number(),
	adAccountId: number(),
	adAccount: optional(AddGoogleAdsAccountDto),
	avbId: string(),
	label: optional(nullable(trimmed(emptyStringIsNull(string())))),
});

export const AddGoogleAdsCampaignBudgetTemplateDto = object({
	id: optional(parsableInteger()),
	budget: number(),
	avbId: string(),
	label: optional(nullable(trimmed(emptyStringIsNull(string())))),
});

export const EditGoogleAdsCampaignBudgetTemplateDto = partial(
	AddGoogleAdsCampaignBudgetTemplateDto
);

export type ViewGoogleAdsCampaignBudgetTemplateDto = Infer<
	typeof ViewGoogleAdsCampaignBudgetTemplateDto
>;

export type AddGoogleAdsCampaignBudgetTemplateDto = Infer<
	typeof AddGoogleAdsCampaignBudgetTemplateDto
>;

export type EditGoogleAdsCampaignBudgetTemplateDto = Infer<
	typeof EditGoogleAdsCampaignBudgetTemplateDto
>;
